import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const integrationLogsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'pspPartnerIds',
    label: 'Bank',
    sortable: false,
  },
  {
    name: 'types',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'url',
    label: 'URL / Event Type',
    sortable: false,
  },
  {
    name: 'transactionIds',
    label: 'Transaction ID',
    sortable: false,
  },
  {
    name: 'requestTime',
    label: 'Request time',
    sortable: false,
    filterModalPlacement: 'right',
    withTimeSelector: true,
  },
  {
    name: 'responseTime',
    label: 'Response time',
    sortable: false,
    filterModalPlacement: 'right',
    withTimeSelector: true,
  },
  {
    name: 'statusCode',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'responseBody',
    label: 'Body',
    sortable: false,
  },
];

export const integrationLogsColumnsLabels = {
  url: 'URL',
  requestTime: 'Request time',
  responseTime: 'Response time',
  statusCode: 'Status',
  pspPartnerIds: 'Bank',
  transactionIds: 'Transaction ID',
};

export const integrationLogsSchema = {
  types: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  transactionIds: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerIds: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  url: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  requestTime: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['requestTimeFrom', 'requestTimeTo'],
    withTimeSelector: true,
  },
  requestTimeFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  requestTimeTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  responseTime: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['responseTimeFrom', 'responseTimeTo'],
    withTimeSelector: true,
  },
  responseTimeFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  responseTimeTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  statusCode: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const integrationLogsFiltersSchema = [
  {
    name: 'url',
    type: FilterType.TEXT,
    placeholder: 'Enter url...',
  },
  {
    name: 'transactionIds',
    type: FilterType.TEXT,
    placeholder: 'Enter ID...',
  },
  {
    name: 'pspPartnerIds',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter company name...',
  },
  {
    name: 'statusCode',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'statusCode',
        title: '200',
        value: '200',
      },
      {
        name: 'statusCode',
        title: '201',
        value: '201',
      },
      {
        name: 'statusCode',
        title: '301',
        value: '301',
      },
      {
        name: 'statusCode',
        title: '400',
        value: '400',
      },
      {
        name: 'statusCode',
        title: '403',
        value: '403',
      },
      {
        name: 'statusCode',
        title: '500',
        value: '500',
      },
      {
        name: 'statusCode',
        title: '504',
        value: '504',
      },
    ],
  },
  {
    name: 'requestTime',
    type: FilterType.DATE_RANGE,
    withoutCustomSelector: true,
    withTimeSelector: true,
    withTwoTimeSelector: true,
  },
  {
    name: 'responseTime',
    type: FilterType.DATE_RANGE,
    withoutCustomSelector: true,
    withTimeSelector: true,
    withTwoTimeSelector: true,
  },
];
